// eslint-disable-next-line no-unused-vars
import {Component, Prop, Watch} from 'vue-property-decorator'
import {FileManager} from '../attachment-manager'
import { eventBus } from '../../main';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_SET_ANNOTATION } from '../../store/document';
import { namespace } from 'vuex-class';

const _window:any = window
const { TABS, TOOLS } = _window.FilerobotImageEditor;

const DocumentStore= namespace(DOCUMENT_MODULE_NAMESPACE)

@Component
class AttachmentButton extends FileManager {

  @DocumentStore.Mutation(DOCUMENT_SET_ANNOTATION)
  storeSetDocumentAnnotation: (payload: {index:number, img:string, name:string}) => void


  /* eslint-disable no-undef */
  fkPhotoAttachement: boolean;
  fkFilenames: string[]
  fkFileRefs: string[]
  fkTypes: string[]
  fkFileBase64: any[]
  fkFileAttr: {
    fk_attribute: number,
    value: number | string | boolean
  }[][]
  fkEditIndex: number
  fkEditModel: string
  fkEditRef: string

  annotationModal:boolean
  annotationComponentId:number
  filerobotImageEditor:any

  constructor () {
    super()

    this.fkPhotoAttachement = false
    this.fkFilenames = []
    this.fkFileRefs = []
    this.fkTypes = []
    this.fkFileBase64 = []
    this.fkFileAttr = []
    this.fkEditIndex = -1
    this.fkEditModel = ''
    this.fkEditRef = ''

    this.annotationModal = false
    this.annotationComponentId = 1
    this.filerobotImageEditor = null
  }

  @Prop({default: null})
  value: any
  @Prop({default: false, type: [Boolean]})
  multiple: boolean
  @Prop({default: 'image/png, image/jpeg', type: [String]})
  accept: string
  @Prop({default: false, type: [Boolean]})
  editMode: boolean
  @Prop({default: () => [], type: [Array]})
  attributes: any[]
  @Watch('attributes')
  handleAttributesChange (value: any[]) {
    this.fillFileAttr()
  }

  get lblSetting () {
    return {
      ...require('@/locales/button').default,
      ...require('@/locales/document').default
    }
  }

  get showAddButton (): boolean {
    return !this.editMode && (this.multiple || !this.fkPhotoAttachement)
  }

  get textConfigs() {
    return require("@/assets/json-resources/text-field-configs.json")
  }

  beforeMount(){
    eventBus.$on('DOC_SAVE_FILES_ATTRIBUTES',()=>{
      console.log('Event.ON ===============> DOC_SAVE_FILES_ATTRIBUTES')
      this.handleUpdateAttachment()
    })
  }

  beforeDestroy(){
    eventBus.$off('DOC_SAVE_FILES_ATTRIBUTES')
  }

  mounted () {
    if (this.value && this.value.length) {
      this.fkFilenames = this.value.map(item => item.name)
      this.fkFileRefs = this.value.map(item => item.reference)
      this.fkFileBase64 = this.value.map(item => item.file)
      this.fkTypes = this.value.map(item => item.type)
      this.fillFileAttr()
    }
  }

  handleAnnotation(index)
  {
    this.annotationModal = true
    this.$nextTick(()=>{
      this.renderEditor(index)
    })
  }

  renderEditor(index)
  {
    //console.log({src:this.src,TOOLS, TABS},)
    this.filerobotImageEditor = null
    const image= new Image()
    image.src = this.fkFileBase64[index]
    // https://github.com/scaleflex/filerobot-image-editor
    const config = {
      source: image,
      defaultSavedImageType:'jpg',
      onSave: (editedImageObject, designState) => {
        console.log('saved', editedImageObject, designState)
        //this.sendFile(editedImageObject, designState)
        this.fkFileBase64[index] = editedImageObject.imageBase64
        this.fkFilenames[index] = editedImageObject.fullName
        this.storeSetDocumentAnnotation({index,img:editedImageObject.imageBase64, name:editedImageObject.fullName})
        this.closePhotoEditor()
      },
      annotationsCommon: {
        fill: '#F92AC2'
      },
      theme:{
        palette: {
          'accent-primary': '#F92AC2',
          'accent-primary-hover':'#2E038C',
          //'accent-primary-active':'#FFFFFF',
          //'bg-primary-active':'#00F4D9',
          'txt-secondary':'#2E038C',
          'icons-primary':'#2E038C',
          'borders-primary':'#F92AC2',
          'borders-secondary':'#F92AC2',
          'warning':'#F92AC2'
        },
        typography: {
          fontFamily: '"Raleway", serif',
        },
      },
      Text: { text: 'Tapez votre texte ...' },
      language:'fr',
      translations: {
        save:'Enregistrer',
      },
      tabsIds: [TABS.ANNOTATE, TABS.ADJUST], // or ['Adjust', 'Annotate', 'Watermark']
      defaultTabId: TABS.ANNOTATE, // or 'Annotate'
      defaultToolId: TOOLS.TEXT, // or 'Text'
    };

    this.filerobotImageEditor =  new _window.FilerobotImageEditor(
      document.querySelector('#editor_container'),
      config
    );

    this.$nextTick(()=>{
      this.filerobotImageEditor.render({
        language:'fr',
        /* onClose: (closingReason) => {
          console.log('Closing reason', closingReason);
          this.closePhotoEditor()
        }, */

      });
    })
  }

  closePhotoEditor()
  {
    this.annotationComponentId += 1
    this.annotationModal = false
  }

  fillFileAttr () {
    this.fkFileAttr = (this.value || []).map(item => {
      return (this.attributes || []).map(attribute => {
        if (item.attributes.find(x => x.fk_attribute === attribute.id)) {
          return item.attributes.find(x => x.fk_attribute === attribute.id)
        } else {
          return this.attributeParam(attribute, null)
        }
      })
    })
  }

  attributeParam (attribute, value = null) {
    let attr = {
      fk_attribute: attribute.id,
      value: value
    }
    if (value === null && attribute.attribute_type.type === 'boolean') attr.value = false
    return attr
  }

  handleAddBlockPhoto () {
    const inputFile: HTMLElement | null = document.getElementById('add-doc-input')

    if (inputFile) {
      inputFile.click()
      inputFile.addEventListener('change', this.onChange)
    }
  }

  onChange (e: any) {
    Array.from(e.target.files).forEach((attachment: File) => {
      if (attachment.size > ((1e+7) * 4)) {
        this.displaySnackBar(this.$t(this.lblSetting.documentTooBigFile, {name: attachment.name}))
        return
      }

      this.fkFilenames = [...this.fkFilenames, attachment.name]
      this.fkTypes = [...this.fkTypes, this.fileType(attachment.type)]
      this.fkFileRefs = [...this.fkFileRefs, '']
      this.fkFileAttr = [...this.fkFileAttr, (this.attributes || []).map(attribute => {
        return this.attributeParam(attribute, null)
      })]
      this.fkPhotoAttachement = true
      this.convertToBase64(attachment)
        .then(file64 => {
          file64.onloadend = () => {
            this.fkFileBase64 = [...this.fkFileBase64, file64.result]
            if (this.multiple) {
              this.$emit('input', this.filesArray(this.fkFileBase64))
              return
            }

            this.$emit('input', this.fkFileBase64[0])
          }
        })
    })
  }

  handleEditAttachment (index) {
    this.fkEditIndex = index
    const documentParts = this.fkFilenames[index].split('.')
    this.fkEditModel = documentParts.slice(0, documentParts.length - 1).join('')
    this.fkEditRef = this.fkFileRefs[index]
  }

  handleUpdateAttachment () {
    if (!this.fkEditModel) return
    this.fkFilenames = this.fkFilenames.map((item, index) => {
      if (index !== this.fkEditIndex) return item
      const documentParts = item.split('.')
      const extension = documentParts[documentParts.length - 1]
      return [this.fkEditModel, extension].join('.')
    })
    this.fkFileRefs[this.fkEditIndex] = this.fkEditRef

    this.fkEditIndex = -1
    this.$emit('input', this.filesArray(this.fkFileBase64))
  }

  handleDeleteAttachment (index) {
    this.fkFilenames.splice(index, 1)
    this.fkTypes.splice(index, 1)
    this.fkFileBase64 = this.fkFileBase64.filter((file, i) => i !== index)
    this.$emit('input', this.multiple ? this.filesArray(this.fkFileBase64) : null)
    this.fkPhotoAttachement = false
  }

  filesArray (Base64Array: any[]) {
    return Base64Array.reduce((accum, current, index) => {
      return [...accum, {
        name: this.fkFilenames[index],
        reference: this.fkFileRefs[index],
        type: this.fkTypes[index],
        file: current,
        attributes: this.fkFileAttr[index].filter(x => x.value !== null /* && x.value !== '' */ && x.value !== undefined)
      }]
    }, [])
  }
}

export default AttachmentButton



// WEBPACK FOOTER //
// ./src/components/attachment-button/index.ts